import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

export default function Trending() {
  const [blog, setBlog] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get("https://tamizhtechie-test.herokuapp.com/blog/")
      .then((res) => {
        setBlog(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const name = "gadget";

  return (
    <div className="trending">
      <div className="row">
        <div className="col-6">
          <h1>Gadgets</h1>
        </div>
        <div className="col-6 text-right align-self-center">
          <Link
            className="read-more"
            to={{
              pathname: "/category/" + name,
            }}
          >
            View More
          </Link>
        </div>
      </div>

      <div className="container">
        {isLoading ? (
          <div>
            <div className="container">
              <div class="col-md-12">
                <div class="row mt-4">
                  <div class="col-12 col-md-4">
                    <div class="ssc-square" style={{ height: 250 }}></div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="ssc-square" style={{ height: 250 }}></div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="ssc-square" style={{ height: 250 }}></div>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-12 col-md-4">
                    <div class="ssc-square" style={{ height: 250 }}></div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="ssc-square" style={{ height: 250 }}></div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="ssc-square" style={{ height: 250 }}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div className="row">
              {blog
                .slice()
                .reverse()
                .map((gadgets, i) => {
                  return (
                    <>
                      <div key={i}>
                        {gadgets.category === "gadget" ? (
                          <Link
                            to={{
                              pathname: "/blog" + "/" + gadgets.slug,
                            }}
                          >
                            <div
                              className="mr-3 mt-3 border-values show"
                              key={gadgets.id}
                            >
                              <div className="text-center item-zoom">
                                <img
                                  className="img-fluid "
                                  src={gadgets.imageUrl}
                                  alt={gadgets.imgalt}
                                />
                              </div>
                              <div className=" border-top">
                                <div className="row">
                                  <div className="col-6">
                                    <h6>{gadgets.category}</h6>
                                  </div>
                                  <div className="col-6 text-right">
                                    <h4>
                                      <i
                                        className="fa fa-calendar pr-3"
                                        aria-hidden="true"
                                      ></i>
                                      {gadgets.date}
                                    </h4>
                                  </div>
                                </div>

                                <h5>{gadgets.title}</h5>
                                {/* <p>{values.para1}</p> */}
                              </div>
                            </div>
                          </Link>
                        ) : null}
                      </div>
                    </>
                  );
                })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
